module.exports = __webpack_public_path__ + "img/papua-new-guinea.9c544b34.png";